import callAPI from "@/actions";
import { CreateContactSchemaType } from "@/schema";
import { HomeResponse } from "@/types/home";
import {
  AboutUsResponse,
  InfoResponse,
  SendMessageResponse,
} from "@/types/info";
import { Page } from "@/types/navigation";
import {
  ClientProjectDetailsResponse,
  ClientProjectsResponse,
  ProjectSiteMap,
} from "@/types/project";
import { SeoResponse } from "@/types/seo";
import {
  ClientServiceDetailsResponse,
  ClientServicesResponse,
  ServiceSiteMap,
} from "@/types/service";

export async function getInfo() {
  return await callAPI<InfoResponse>({
    endpoint: "/info",
    method: "GET",
    next: {
      revalidate: 60 * 3,
    },
  });
}

export const cachedGetInfo = getInfo;

export async function getNavigations() {
  return await callAPI<Page[]>({
    endpoint: "/navigations",
    method: "GET",
    next: {
      revalidate: 60 * 3,
    },
  });
}

export const cachedGetNavigations = getNavigations;

export async function getAboutUs() {
  return await callAPI<AboutUsResponse>({
    endpoint: "/info/about-us",
    method: "GET",
    next: {
      revalidate: 60 * 3,
    },
  });
}

export const cachedGetAboutUs = getAboutUs;

export async function getHome() {
  return await callAPI<HomeResponse>({
    endpoint: "/home",
    method: "GET",
    next: {
      revalidate: 60,
    },
  });
}

export const cachedGetHome = getHome;

export async function getServices() {
  return await callAPI<ClientServicesResponse>({
    endpoint: "/services",
    method: "GET",
    next: {
      revalidate: 60 * 2,
    },
  });
}

export const cachedGetServices = getServices;

export async function getProjects() {
  return await callAPI<ClientProjectsResponse>({
    endpoint: "/projects",
    method: "GET",
    next: {
      revalidate: 60 * 2,
    },
  });
}

export const cachedGetProjects = getProjects;

export async function getProject(id: number) {
  return await callAPI<ClientProjectDetailsResponse>({
    endpoint: `/projects/${id}`,
    method: "GET",
    next: {
      revalidate: 60 * 2,
    },
  });
}

export async function getProjectsSiteMap() {
  return await callAPI<ProjectSiteMap[]>({
    endpoint: "/seo/get-all-projects",
    method: "GET",
    locale: "ar", // Bypass cookies
  });
}

export const cachedGetProjectsSiteMap = getProjectsSiteMap;

export async function getServicesSiteMap() {
  return await callAPI<ServiceSiteMap[]>({
    endpoint: "/seo/get-all-services",
    method: "GET",
    locale: "ar", // Bypass cookies
  });
}

export const cachedGetProject = getProject;

export async function getService(id: number) {
  return await callAPI<ClientServiceDetailsResponse>({
    endpoint: `/services/${id}`,
    method: "GET",
    next: {
      revalidate: 60 * 2,
    },
  });
}

export const cachedGetService = getService;

export async function sendMessage(data: CreateContactSchemaType) {
  return await callAPI<SendMessageResponse>({
    endpoint: "/info/send-message",
    method: "POST",
    body: data,
  });
}

export const getSEO = async (route: string) => {
  return await callAPI<SeoResponse>({
    endpoint: `/seo/get-seo?route=${route}`,
    method: "GET",
    next: {
      revalidate: 60 * 3,
    },
  });
};
